import { createContext } from 'react'

export const ForgotPasswordContext = createContext({
  isForgotPassword: false,
  setIsForgotPassword: (val) => {}
})